export {
  VideoHighlight,
  calculateVideoHighlightMetadata,
} from './VideoHighlight';
export type {
  HighlightItem,
  HighlightType,
  Position,
  VideoHighlightProps,
} from './types';
export {videoHighlightSchema} from './types';
